export enum Platform {
  Desktop,
  Mobile,
}
